import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconChartPieComponent } from "./med-icon-chart-pie.component";

@NgModule({
  declarations: [
    MedIconChartPieComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconChartPieComponent,
  ],
})
export class MedIconChartPieModule { }
